import { IUserModel } from "../interfaces/model";

export const userToString = (user: IUserModel) => {
    if (user.firstname || user.lastname) {
        return user.firstname + " " + user.lastname;
    }

    return user.username;
};
